import { useState, useEffect } from "react";
import { Button, Stack, Text } from "basis";
import { usePageTracking } from "react-event-tracker";
import { postResendOtp, postLinkOtp } from "library/api";
import { formatMaskedMobile } from "library/utils";
import { Layout } from "../../Layout/Layout";
import { OtpInput } from "../../OtpInput/OtpInput";
import { getFatalErrorContent } from "../LinkingErrorContent";

export const LinkingOTP = ({ setScreen, params, toggleWrapper }) => {
  const {
    linkId,
    maskedMobile = "",
    currentStep,
    account_last4: accountLast4,
  } = params;
  const [state, setState] = useState({
    loading: false,
    filled: false,
    error: "",
    value: "",
    fatalError: false,
  });
  const { loading, filled, error, value, fatalError } = state;

  const { siteSubSection, productId } = params;
  usePageTracking({
    page: {
      pageType: "input-page",
      siteSection: "accounts",
      siteSubSection,
      pageTitle: "verification",
    },
    user: {
      authenticationStatus: "logged in",
    },
    productId: [productId],
  });

  const updateState = (newState) =>
    setState({
      ...state,
      ...newState,
    });
  const formattedMobile = formatMaskedMobile(maskedMobile);

  useEffect(() => {
    if (fatalError) {
      setScreen("FatalError", {
        ...params,
        error: fatalError,
      });
    }
  }, [fatalError, params, setScreen]);

  return (
    <Layout>
      <Layout.Header>
        Link {accountLast4 ? "credit card" : "personal loan"} account
      </Layout.Header>
      <Layout.Main>
        <form>
          <Stack gap="6" width="360">
            <Text as="h3" textStyle="heading5">
              Check your phone
            </Text>
            <Text>
              We've just sent an SMS verification code to{" "}
              <strong>{formattedMobile}</strong>. Please enter the 4 digit code.
            </Text>
            <OtpInput
              numInputs={4}
              errorMessage={error}
              resendOtp={() => postResendOtp(linkId)}
              onChange={(e) =>
                updateState({
                  filled: !!e.success,
                  value: e.value,
                })
              }
            />
            <Button
              width="160"
              loading={loading}
              disabled={!filled}
              onClick={async (event) => {
                event.preventDefault();
                updateState({ loading: true });
                const newState = { loading: false };
                try {
                  await postLinkOtp({
                    id: linkId,
                    data: {
                      otp: value.toString(),
                    },
                  });
                } catch (e) {
                  const newError =
                    e.response && e.response.data
                      ? e.response.data.message
                      : `Sorry, we've encountered an unexpected problem.`;
                  newState.error = newError;
                  // check for fatal error
                  newState.fatalError = getFatalErrorContent(e.response.data);
                }

                updateState(newState);
                setScreen(!newState.error ? "Success" : null, {
                  ...params,
                  currentStep: currentStep + 1,
                });

                // As this will unmount the component it needs to be called after any local state updates
                if (!newState.error && toggleWrapper) {
                  toggleWrapper();
                }
              }}
            >
              Verify
            </Button>
          </Stack>
        </form>
      </Layout.Main>
    </Layout>
  );
};
